import { render, staticRenderFns } from "./DuelsGameRoller.vue?vue&type=template&id=16a03a84&scoped=true"
import script from "./DuelsGameRoller.vue?vue&type=script&lang=js"
export * from "./DuelsGameRoller.vue?vue&type=script&lang=js"
import style0 from "./DuelsGameRoller.vue?vue&type=style&index=0&id=16a03a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a03a84",
  null
  
)

export default component.exports